import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { ProgressbarModule } from "ngx-bootstrap/progressbar";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { CollapseModule } from "ngx-bootstrap/collapse";
import { TabsModule } from "ngx-bootstrap/tabs";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { AlertModule } from "ngx-bootstrap/alert";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { CarouselModule } from "ngx-bootstrap/carousel";
import { ModalModule } from "ngx-bootstrap/modal";
import { PopoverModule } from "ngx-bootstrap/popover";

import {LandingPageComponent} from "./landing-page/landing-page.component";
import {ScrollToTopComponent} from "./scroll-to-top/scroll-to-top.component";
import { ReviewPageComponent } from './review-page/review-page.component';
import { OnlineAdmissionsComponent } from './online-admissions/online-admissions.component';
import { PreviewPageComponent } from './online-admissions/preview-page/preview-page.component';
import { PaymentPageComponent } from './online-admissions/payment-page/payment-page.component';
import {SignUp2Component} from "./sign-up2/sign-up2.component";

@NgModule({
  declarations: [
    LandingPageComponent,
    ScrollToTopComponent,
    ReviewPageComponent,
    OnlineAdmissionsComponent,
    PreviewPageComponent,
    PaymentPageComponent,
    SignUp2Component
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    RouterModule,
    BsDropdownModule.forRoot(),
    ProgressbarModule.forRoot(),
    TooltipModule.forRoot(),
    PopoverModule.forRoot(),
    CollapseModule.forRoot(),
    TabsModule.forRoot(),
    PaginationModule.forRoot(),
    AlertModule.forRoot(),
    BsDatepickerModule.forRoot(),
    CarouselModule.forRoot(),
    ModalModule.forRoot()
  ],
  exports: [
    LandingPageComponent,
    ScrollToTopComponent
  ]
})
export class LandingModule { }
